module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "iconbox"
  }, [_c('label', [_vm._v("Choose Color:")]), _vm._v(" "), _c('div', _vm._l((_vm.renderColors), function(icon) {
    return _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.changeIcon(icon)
        }
      }
    }, [_c('icon', {
      attrs: {
        "code": icon
      }
    })], 1)
  }), 0)]), _vm._v(" "), (_vm.double) ? _c('div', {
    staticClass: "iconbox"
  }, [_c('label', [_vm._v("Choose Shape:")]), _vm._v(" "), _c('div', _vm._l((_vm.renderShapes), function(icon) {
    return _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.changeIcon(icon)
        }
      }
    }, [_c('icon', {
      attrs: {
        "code": icon
      }
    })], 1)
  }), 0)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aafc352"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/iconbox.vue
// module id = 195
// module chunks = 0